import download from 'downloadjs'

class FICNetwork {
}

FICNetwork.download = (url, method = 'GET', params, filename) => {
  let xhr = new XMLHttpRequest()
  xhr.open(method, url, true)
  xhr.responseType = 'blob'

  if (method === 'POST') { xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') }

  xhr.onload = function (e) {
    if (!filename) {
      const headers = xhr.getAllResponseHeaders().split('\n')

      let disposition = headers.filter((header) => header.startsWith('content-disposition'))

      if (disposition.length > 0) { filename = headerFilename(disposition[ 0 ]) } else { filename = url.split('/').pop().split('?')[ 0 ] }
    }

    download(e.target.response, filename)
  }
  if (method === 'POST') { xhr.send($.param(params || {})) } else { xhr.send() }
}

export function headerFilename (disposition) {
  let filename = ''
  if (disposition && disposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    const matches = filenameRegex.exec(disposition)
    if (matches !== null && matches[ 1 ]) {
      filename = matches[ 1 ].replace(/['"]/g, '')
    }
  }
  return filename
}

FICNetwork.print = (url) => {
  if (!url.startsWith(window.location.origin)) {
    url = reactGlobalParams.api_host + '/download?url=' + url
  }
  const w = window.open(url)
  setTimeout(() => { w.print() }, 1000)
}

// Redirect jQuery code

;(function ($) {
  $.redirect = function (target, values, method) {
    method = (method && method.toUpperCase() === 'GET') ? 'GET' : 'POST'

    if (!values) {
      var obj = $.parse_url(target)
      target = obj.url
      values = obj.params
    }

    var form = $('<form>', {
      attr: {
        method: method,
        action: target
      }
    })

    for (var i in values) {
      $('<input>', {
        attr: {
          type: 'hidden',
          name: i,
          value: values[ i ]
        }
      }).appendTo(form)
    }

    $('body').append(form)
    form.submit()
  }

  $.parse_url = function (url) {
    if (url.indexOf('?') === -1) { return { url: url, params: {} } }

    var parts = url.split('?')
    var url = parts[ 0 ]
    var query_string = parts[ 1 ]

    var return_obj = {}
    var elems = query_string.split('&')

    var obj = {}

    for (var i in elems) {
      var elem = elems[ i ]
      var pair = elem.split('=')
      obj[ pair[ 0 ] ] = pair[ 1 ]
    }

    return_obj.url = url
    return_obj.params = obj

    return return_obj
  }
})(jQuery)

export default FICNetwork



// WEBPACK FOOTER //
// ./src/common/network/js/FICNetwork.js